module.exports = __webpack_public_path__ + "media/images/dividend/success-6969543866cf11e74f8bbeb5b5847a70.gif";